import { useMemo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";

import Stack from "components/Stack";
import Text from "components/Text";

import PrintableMemoFieldTitle from "pages/Deal/PrintableMemo/components/PrintableMemoFieldTitle";

import { IPackageDetailsField } from "entities/Checklist/sdk";
import { formatFieldValue } from "entities/Field/utils";

interface IPrintableTextfield {
  field: IPackageDetailsField;
  isNASection: boolean;
}

const PrintableTextfield = ({ field, isNASection }: IPrintableTextfield) => {
  const value = useMemo(
    () => _.first(field.values)?.default_value,
    [field.values]
  );

  const isNAField = useMemo(
    () => field.n_a_status || isNASection,
    [field, isNASection]
  );

  const showFieldValue = useMemo(() => !isNAField && value, [isNAField, value]);

  return (
    <Stack direction="row" sx={{ borderBottom: `1px solid ${colors.blue40}` }}>
      <PrintableMemoFieldTitle field={field} disabled={isNAField} />
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ flex: 1 }}
        justifyContent="flex-end"
      >
        {showFieldValue && (
          <Text variant="text2" data-testid="field-value">
            {formatFieldValue({
              fieldValue: value,
              fieldFormatType: field.field_format_type,
            })}
          </Text>
        )}
        {isNAField && (
          <Text sx={{ opacity: 0.5 }} data-testid="field-value-na">
            N/A
          </Text>
        )}
      </Stack>
    </Stack>
  );
};

export default PrintableTextfield;
